import { useState, useEffect } from 'react';
import axios from 'axios';
import { show_alerta } from '../../funciones.js';
import CONFIG from '../../config.js';

const URL_CUOTAS = `${CONFIG.API_URL}/operarCuotas.php`;
const URL_COHORTES = `${CONFIG.API_URL}/operarCohortes.php`;

function Cuotas() {
    const [cohortes, setCohortes] = useState([]);
    const [cohorte, setCohorte] = useState('');
    const [mes, setMes] = useState('');
    const [montoOriginal, setMontoOriginal] = useState('');
    const [fechaVencimiento, setFechaVencimiento] = useState('');
    const cicloActual = new Date().getFullYear();
    const [mesesGenerados, setMesesGenerados] = useState([]);
    const [mesesGeneradosTodos, setMesesGeneradosTodos] = useState([]);

    const meses = [
        'Enero','Febrero','Marzo','Abril','Mayo','Junio',
        'Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'
    ];


    useEffect(() => {
        obtenerCohortes();
        obtenerTodosMesesGenerados();
    }, []);


    // consultar la api para obtener las cohortes creadas este año
    const obtenerCohortes = async () => {
        const res = await axios.get(`${URL_COHORTES}?ciclo=${cicloActual}`);
        if (res.data.success) {
            setCohortes(res.data.cohortes);
        } else {
            setCohortes([]);
            alert('Error: ' + res.data.message);
        }
    };
    //funcion ara  obtener todos las cuotas  generadas por mes ao y formacion
    const obtenerTodosMesesGenerados= async () => {
        try {
            const res = await axios.get(URL_CUOTAS);
            console.log('cuotas:',res.data);
            if (res.data.success) {
                setMesesGeneradosTodos(res.data.mesesGeneradosTodos);
            } else {
                setMesesGeneradosTodos([]);
            }
        } catch (err) {
            console.error(err);
            setMesesGeneradosTodos([]);
        }
    };
    //funcion para quitar los meses que ya se genero la cuota
    const obtenerMesesGenerados = async (cohorteSeleccionado) => {
        try {
            const res = await axios.get(`${URL_CUOTAS}?cohorte=${cohorteSeleccionado}`);
            if (res.data.success) {
                setMesesGenerados(res.data.mesesGenerados);
            } else {
                setMesesGenerados([]);
            }
        } catch (err) {
            console.error(err);
            setMesesGenerados([]);
        }
    }; 

    //funcion para generar las cuotas a pagar segun la seleccion
    const generarCuotas = async () => {
        if (!cohorte || !mes || !montoOriginal || !fechaVencimiento) {
            show_alerta('Debe completar todos los campos', 'warning');
            return;
        }
        console.log('resPrev:',cohorte, '-' ,mes, '-',montoOriginal, '-',fechaVencimiento);
        try {
            const res = await axios.post(URL_CUOTAS, {
                cohorte,
                mes,
                monto_original: montoOriginal,
                fecha_vencimiento: fechaVencimiento
            });
            console.log('res:',res.data);
            if (res.data.success) {
                show_alerta('Cuotas generadas correctamente', 'success');
                obtenerTodosMesesGenerados();
            } else {
                show_alerta('Error: ' + res.data.mensaje, 'error');
            }
        } catch (err) {
            console.error(err);
            show_alerta('Error al generar cuotas', 'error');
        }
    };

    return (
        <div className='container-principal'>
            <div className='card shadow border-1 p-4 mb-4'>
                <h3>Gestión de cuotas</h3>
                <h5>Cuotas ya generadas</h5>
                <div className='d-flex d-wrap'>
                {mesesGeneradosTodos.length!=0 && mesesGeneradosTodos.map((cu,index)=>(
                    <div key={index} className='card shadow text-center mx-2 mb-4 p-2'>
                        <h6>{cu.nombre_formacion}</h6> 
                        <div className='my-1'>{cu.mes}/ {cu.anio} <i className="fa-solid fa-check text-success"></i></div> 
                        <p style={{color:'#888', fontSize:'10px'}}>{cu.fecha_creacion}</p>
                    </div>
                ))}
                </div>
            </div>
            {/* Selección de cohorte */}
            {/* Cuando seleccionás cohorte, llamás también a obtenerMesesGenerados*/}
            <h5>Generar nuevas cuotas</h5>
            <label>Cohorte</label>
            <select
                className="form-select mb-2"
                value={cohorte}
                onChange={e => {
                    setCohorte(e.target.value);
                    obtenerMesesGenerados(e.target.value);
                }}
            >
                <option value="">Seleccione cohorte</option>
                {cohortes.map(item => (
                    <option key={item.id} value={item.id}>
                        {item.nombre_formacion} ({item.año})
                    </option>
                ))}
            </select>

            {/* Selección de mes */}
            <label>Mes</label>
            <select
                className="form-select mb-2"
                value={mes}
                onChange={e => setMes(e.target.value)}
            >
                <option value="">Seleccione mes</option>
                {meses.map((m, index) => {
                    const numeroMes = index + 1;
                    if (!mesesGenerados.includes(numeroMes)) {
                        return (
                            <option key={numeroMes} value={numeroMes}>
                                {m}
                            </option>
                        );
                    }
                    return null; // no renderiza los meses ya generados
                })}
            </select>

            {/* Monto original */}
            <label>Monto original</label>
            <input
                type="number"
                className="form-control mb-2"
                placeholder="Monto original"
                value={montoOriginal}
                onChange={e => setMontoOriginal(e.target.value)}
            />

            {/* Fecha de vencimiento */}
            <label>Fecha de vencimiento</label>
            <input
                type="date"
                className="form-control mb-2"
                value={fechaVencimiento}
                onChange={e => setFechaVencimiento(e.target.value)}
            />

            {/* Botón generar */}
            <button
                type='button'
                className='btn btn-success mb-2'
                onClick={generarCuotas}
            >
                Generar cuotas
            </button>
        </div>
    );
}

export default Cuotas;
